import renderSeatInformationHeader from './renderSeatInformationHeader';
import renderPriceTypeDetails from './renderPriceTypeDetails';
import renderPriceTypeListHeading, { PRICE_TYPE_LIST_HEADING_ID } from './renderPriceTypeListHeading';
import renderOrderLevelFeeDisclaimer, { OrderLevelFeeDisclaimerConfig } from './renderOrderLevelFeeDisclaimer';
import type SyosSeat from '../SyosSeat';
import { ExtendedPriceTypeData } from '../api/types';
import { IPriceTypeSelectionHelper } from '../priceTypeSelectionHelpers/types';
import { ISyosLabels } from '../labels/types';

function renderPriceTypeList(labels: ISyosLabels, priceTypes: ExtendedPriceTypeData[], config: OrderLevelFeeDisclaimerConfig) {
  const priceTypeListHeadingLabel = priceTypes.length > 1
    ? labels.multipleTicketTypesForSeatLabel
    : labels.singleTicketTypesForSeatLabel;

  const heading = renderPriceTypeListHeading(priceTypeListHeadingLabel);

  const orderLevelFeeDisclaimer = renderOrderLevelFeeDisclaimer(config);

  return `${orderLevelFeeDisclaimer}
  ${heading}
  <ul class="list-unstyled tn-syos-seat-info__price-type-list" aria-labelledby="${PRICE_TYPE_LIST_HEADING_ID}">
    ${priceTypes.map(renderPriceTypeListItem).join('')}
  </ul>`;
}

function escapeDoubleQuotes(value: string) {
  return value.replace(/"/gi, '&quot;');
}

function renderPriceTypeListItem(priceType: ExtendedPriceTypeData) {
  const {
    price_type: id,
    priceTypeSelectionButtonAccessibleName,
  } = priceType;

  const ariaLabel = escapeDoubleQuotes(priceTypeSelectionButtonAccessibleName);

  return `<li class="tn-syos-seat-info__price-type-list-item">
    <button data-price-type-id="${id}" type="button" aria-label="${ariaLabel}" class="btn btn-primary tn-syos-seat-info__price-type tn-syos-seat-info__price-type--button">
        ${renderPriceTypeDetails(priceType)}
    </button>
  </li>`;
}

function renderNextPriceTypeForFlexMode(priceType: ExtendedPriceTypeData) {
  const { priceTypeSelectionButtonAccessibleName } = priceType;

  const ariaLabel = escapeDoubleQuotes(priceTypeSelectionButtonAccessibleName);

  return `<div class="tn-syos-seat-info__price-type-list">
      <div aria-label="${ariaLabel}" class="tn-syos-seat-info__price-type tn-syos-seat-info__price-type--button">
          ${renderPriceTypeDetails(priceType)}
      </div>
    <div>
  </div>`;
}

function render(labels: ISyosLabels, seat: SyosSeat, priceTypeSelectionHelper: IPriceTypeSelectionHelper, config: OrderLevelFeeDisclaimerConfig) {
  const header = renderSeatInformationHeader(seat);

  const allSeatPriceTypes = seat.getPriceTypes();

  const filteredPriceTypes = priceTypeSelectionHelper.getFilteredPriceTypes(allSeatPriceTypes);

  if (priceTypeSelectionHelper.mode === 'flex') {
    const nextPriceType = filteredPriceTypes[0];

    return `<div>${header}${renderNextPriceTypeForFlexMode(nextPriceType)}</div>`;
  }

  return `<div>${header}${renderPriceTypeList(labels, filteredPriceTypes, config)}</div>`;
}

export default {
  render,
};
